import React, { useState } from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../common-components";

const UserListItem = ({ userName, onClick, email, cellNumber }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={{
        minHeight: 50,
        width: "100%",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        backgroundColor: hover ? colors.primaryBlue50 : colors.white,
        marginBottom: 2,
        transition: "all 0.1s",
      }}
    >
      <div
        style={{
          flex: 0.2,
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 13,
            fontWeight: hover ? "bold" : "normal",
            marginLeft: 20,
          }}
        >
          {userName}
        </div>
      </div>
      <div
        style={{
          flex: 0.15,

          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 13,
            fontWeight: hover ? "bold" : "normal",
            width: "90%",
          }}
        >
          {cellNumber}
        </div>
      </div>
      <div
        style={{
          flex: 0.2,

          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 13,
            fontWeight: hover ? "bold" : "normal",
            width: "90%",
          }}
        >
          {email}
        </div>
      </div>
      <div
        style={{
          flex: 0.35,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 13,
            fontWeight: hover ? "bold" : "normal",
            width: "90%",
          }}
        >
          LAST TASK
        </div>
      </div>
      <div
        style={{
          flex: 0.1,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"VIEW"}
          backgroundColor={colors.primaryBlue}
          borderRadius={8}
          width={120}
          height={35}
          onClick={onClick}
        />
      </div>
    </div>
  );
};

export default UserListItem;
